/* eslint-disable jsx-a11y/anchor-has-content */
import styled from 'styled-components';
import ThemedIcon from '../../common/ThemedIcon';
import { useDispatch } from 'react-redux';

import { openFileViewer } from '../../../actions';

import arrowRight from '../../../images/common/arrow-right.svg';
import userIcon from '../../../images/consultations/new-flow/user-icon.svg';
import clockIcon from '../../../images/lab-test/green-clock.svg';
import calendarIcon from '../../../images/lab-test/order-calendar.svg';
import crossFillIcon from '../../../images/lab-test/cross-fill.svg';
import pdfIcon from '../../../images/lab-test/pdf-icon.svg';
import eyeIcon from '../../../images/common/eye.svg';
import hashTag from '../../../images/refund-status-tele/hashtag.svg';
import completeIcon from '../../../images/refund-status-tele/complete.svg';
import cancelledIcon from '../../../images/refund-status-tele/cancelled.svg';
import infoIcon from '../../../images/refund-status-tele/info.svg';
import doneFill from '../../../images/refund-status-tele/done.svg';

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(230, 233, 236, 1);
  margin-bottom: 16px;
  border-radius: 12px;
`;

const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
  padding-right: 24px;
  border-bottom: 1px solid rgba(240, 243, 246, 1);
`;

const DoctorDetailsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ArrowIcon = styled.img``;

const MiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  padding-left: 16px;
  padding-bottom: 16px;
`;

const MiddleSubContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const PrescriptionContainer = styled.div`
  display: flex;
  padding-top: 12px;
  padding-left: 16px;
  padding-bottom: 12px;
  border-top: 1px solid rgba(240, 243, 246, 1);
`;

const RefundStatusContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 12px;
  padding-left: 16px;
  padding-bottom: 12px;
  border-top: 1px solid rgba(240, 243, 246, 1);
  cursor: pointer;
`;

const RefundStatusText = styled.div`
  color: var(--Primary, var(--primary-button));
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.25px;
`;

const ConsultationOrderCard = ({
  order,
  onlinePreview,
  onTap,
  refundStatusModal,
}) => {
  const dispatch = useDispatch();
  const renderUploadedFile = (ele, idx) => {
    if (idx > 3) return;

    if (true) {
      return (
        <div
          className="relative mr-15 w-52px h-76px mt-8px mb-8px rounded-12 bg-contain bg-no-repeat"
          style={{ backgroundImage: `url(${pdfIcon})` }}
          onClick={(e) => {
            try {
              if (ele.fileUrl) {
                dispatch(
                  openFileViewer({
                    contentUrl: ele.fileUrl,
                    title: 'Order',
                    type: 'pdf',
                  })
                );
              }
            } catch (err) {
              e.stopPropagation();
              window.open(ele.fileUrl, '_blank');
            }
          }}
        >
          <a
            href={ele.fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            id={`image-anchor-${ele.fileId}`}
            style={{ display: 'none' }}
          >
            {}
          </a>
        </div>
      );
    }
    return (
      <div
        className="relative mr-15 w-52px h-76px mt-8px mb-8px rounded-12 bg-cover bg-no-repeat bg-opacity-20 custom-opacity"
        style={{ backgroundImage: `url(${ele.fileUrl})` }}
      >
        <a
          href={ele.fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          id={`image-anchor-${ele.fileId}`}
          style={{ display: 'none' }}
        />
        <img
          onClick={(e) => {
            e.stopPropagation();
            try {
              if (ele.fileUrl) {
                dispatch(
                  openFileViewer({
                    contentUrl: ele.fileUrl,
                    title: 'Order',
                    type: 'image',
                  })
                );
              }
            } catch (err) {
              window.open(ele.fileUrl, '_blank');
            }
          }}
          src={eyeIcon}
          alt="eye"
          className="absolute top-24px left-12px"
        />
      </div>
    );
  };

  return (
    <CardContainer onClick={onTap}>
      <TopContainer>
        <DoctorDetailsContainer>
          <img
            src={order.profileImg}
            alt="doctor"
            width={'56px'}
            height={'56px'}
            style={{ borderRadius: '12px' }}
          />
          <div className="flex flex-col ml-12px">
            <p className="text-body-l font-semibold text-txtlight">
              {order.doctorName}
            </p>
            <p className="text-body-s text-sub">{order.vertical}</p>
          </div>
        </DoctorDetailsContainer>
        <ThemedIcon
          src={arrowRight}
          alt=""
          style={{
            color: 'red',
            width: '14px',
            height: '12px',
          }}
        />
      </TopContainer>
      <div className="flex justify-between">
        <MiddleContainer>
          <MiddleSubContainer>
            <ThemedIcon
              src={userIcon}
              alt="patient-icon"
              className="self-start"
              width="16px"
              height="16px"
            />
            <div className="ml-8px flex gap-1">
              <p className="text-body-s font-medium text-txtsecondary-greyShade">
                {order.patientLabel || 'Patient'}:{' '}
              </p>
              <p className="font-semibold text-body-s text-txtlight">
                {order.patientName}
              </p>
            </div>
          </MiddleSubContainer>
          <MiddleSubContainer>
            <ThemedIcon src={hashTag} alt="hashtag" className="self-start" />
            <div className="ml-8px flex gap-1">
              <p className="text-body-s font-medium text-txtsecondary-greyShade">
                Appointment ID:
              </p>
              <p className="font-semibold text-body-s text-txtlight">
                {order.consultationId}
              </p>
            </div>
          </MiddleSubContainer>
          <MiddleSubContainer>
            <img src={clockIcon} alt="clock-icon" className="self-start"></img>
            <div className="ml-8px flex gap-1">
              <p className="text-body-s font-medium text-txtsecondary-greyShade">
                Placed On:
              </p>
              <p className="font-semibold text-body-s text-txtlight">
                {order.requestDate}
              </p>
            </div>
          </MiddleSubContainer>
          <MiddleSubContainer>
            <img
              src={calendarIcon}
              alt="calendar-icon"
              className="self-start"
            ></img>
            <div className="ml-8px flex gap-1 w-full">
              <p className="text-body-s font-medium text-txtsecondary-greyShade">
                Appointment On:
              </p>
              <p className="font-semibold text-body-s text-txtlight">
                {order.consultDate}
              </p>
            </div>
          </MiddleSubContainer>
          {!order.cancelled &&
            order.daysRemaining === 0 &&
            !order.isScheduledConsultation && (
              <MiddleSubContainer>
                <img
                  src={completeIcon}
                  alt="tick-icon"
                  className="self-start"
                ></img>
                <div className="ml-8px flex gap-1">
                  <p className="text-body-s font-medium text-txtsecondary-greyShade">
                    Completed:
                  </p>
                  <p className="font-semibold text-body-s text-txtlight">
                    {order.endedOn
                      ? order.endedOn
                      : `Started on ${order.consultDate}`}
                  </p>
                </div>
              </MiddleSubContainer>
            )}
          {/* {
            !order.cancelled && order.daysRemaining === 0 && order.isScheduledConsultation && (
              <MiddleSubContainer>
                <img src={completeIcon} alt="tick-icon" className="self-start"></img>
                <div className="ml-8px flex gap-1">
                  <p className="text-body-s font-medium text-txtsecondary-greyShade">
                    Completed:
                  </p>
                  <p className="font-semibold text-body-s text-txtlight">
                    {order.endedOn ? order.endedOn : `Started on ${order.consultDate}`}
                  </p>
                </div>
              </MiddleSubContainer>
            )
          } */}
          {!order.cancelled &&
            order.daysRemaining !== 0 &&
            !order.isScheduledConsultation && (
              <MiddleSubContainer>
                <img
                  src={calendarIcon}
                  alt="calendar-icon"
                  className="self-start"
                ></img>
                <div className="ml-8px flex gap-1 min-w-full">
                  <p className="text-body-s font-medium text-txtsecondary-greyShade">
                    Consultation days left:
                  </p>
                  <p className="font-semibold text-body-s">
                    {/* {`${order.daysRemaining > 1 ? `${order.daysRemaining} days` : `${order.daysRemaining} day`}`} */}
                    {order.daysRemaining}
                  </p>
                </div>
              </MiddleSubContainer>
            )}
          {order.cancelled && order.cancelReason && (
            <MiddleSubContainer>
              <img
                src={infoIcon}
                alt="calendar-icon"
                className="self-start"
              ></img>
              <div className="ml-8px flex gap-1">
                <p className="text-body-s font-medium text-txtsecondary-greyShade">
                  Reason:
                </p>
                <p className="font-semibold text-body-s text-txtlight">
                  {order.cancelReason}
                </p>
              </div>
            </MiddleSubContainer>
          )}
          {order.cancelled && (
            <MiddleSubContainer>
              <img
                src={cancelledIcon}
                alt="calendar-icon"
                className="self-start"
              ></img>
              <div className="ml-8px flex gap-1">
                <p className="font-semibold text-body-s text-txtlight">
                  {order.cancelledAt}
                </p>
              </div>
            </MiddleSubContainer>
          )}
        </MiddleContainer>
        {order.cancelled && (
          <div
            className="flex items-end"
            style={{
              paddingTop: '12px',
              paddingLeft: '16px',
              paddingBottom: '16px',
              paddingRight: '24px',
              marginBottom: '8px',
            }}
          >
            <img
              src={crossFillIcon}
              width={'14px'}
              height={'14px'}
              className="mb-2px"
              alt=""
            />
            <p className="text-body-s font-semibold text-accent2-shades4 ml-4px">
              Cancelled
            </p>
          </div>
        )}
        {!order.cancelled &&
          order.daysRemaining !== 0 &&
          !order.isScheduledConsultation && (
            <div
              className="flex items-end"
              style={{
                paddingTop: '12px',
                paddingLeft: '16px',
                paddingBottom: '16px',
                paddingRight: '24px',
                marginBottom: '8px',
              }}
            >
              <div
                // style={{ color: '#E7FAFF' }}
                className="text-txtsecondary-greyShade"
              >
                <p className="font-semibold text-body-s">
                  {`${
                    order.daysRemaining > 1
                      ? `${order.daysRemaining} days`
                      : `${order.daysRemaining} day`
                  }`}
                </p>
              </div>
            </div>
          )}
        {order.endedOn && !order.cancelled && (
          <div
            className="flex items-end"
            style={{
              paddingTop: '12px',
              paddingLeft: '16px',
              paddingBottom: '16px',
              paddingRight: '24px',
              marginBottom: '8px',
            }}
          >
            <img
              src={doneFill}
              width={'14px'}
              height={'14px'}
              className="mb-2px"
              alt=""
            />
            <p
              className="text-body-s font-semibold ml-4px"
              style={{ color: '#7DCC18' }}
            >
              Completed
            </p>
          </div>
        )}
      </div>
      {order.uploads && order.uploads.length > 0 && (
        <PrescriptionContainer className="flex justify-start flex-row items-center">
          {order.uploads.map(renderUploadedFile)}
        </PrescriptionContainer>
      )}
      {order.cancelled && order.trackRefund === 1 && (
        <RefundStatusContainer
          onClick={(e) => {
            e.stopPropagation();
            refundStatusModal(order);
          }}
        >
          <RefundStatusText>Track Refund Status</RefundStatusText>
        </RefundStatusContainer>
      )}
    </CardContainer>
  );
};

export default ConsultationOrderCard;
